export interface ITranslation {
    key: string;
    value: string;
}

export interface IAirtableField {
    Key: string;
    'ar-SA': string;
    'cs-CZ': string;
    'da-DK': string;
    'de-DE': string;
    'en-GB': string;
    'en-US': string;
    'es-ES': string;
    'fi-FI': string;
    'fr-FR': string;
    'it-IT': string;
    'ja-JP': string;
    'ko-KR': string;
    'nb-NO': string;
    'nl-NL': string;
    'pl-PL': string;
    'pt-BR': string;
    'ru-RU': string;
    'sv-SE': string;
    'zh-CN': string;
    'zh-TW': string;
}

export interface IAppTranslations {
    common_help: string | undefined;
    common_edit: string | undefined;
    common_close: string | undefined;
    common_update: string | undefined;
    common_yes: string | undefined;
    common_no: string | undefined;
    common_confirmation: string | undefined;
    common_warning: string | undefined;
    common_okay: string | undefined;
    common_save: string | undefined;
    common_submit: string | undefined;
    common_continue: string | undefined;

    assessment_questions_unanswered: string | undefined;
    assessment_observer: string | undefined;
    assessment_demographics: string | undefined;
    assessment_saveAndExit: string | undefined;
    assessment_approx_time_left: string | undefined;
    assessment_yourDemographics: string | undefined;
    assessment_questions_most: string | undefined;
    assessment_questions_next: string | undefined;
    assessment_questions_noComment: string | undefined;
    assessment_questions_noCommentChoice: string | undefined;
    assessment_questions_section: string | undefined;
    assessment_questions_instructions: string | undefined;
    assessment_button_back: string | undefined;
    assessment_button_nextSection: string | undefined;
    assessment_button_allDone: string | undefined;
    assessment_button_firstQuestion: string | undefined;
    assessment_submit_demographics: string | undefined;
    assessment_return_message: string | undefined;
    assessment_welcome_back: string | undefined;
    assessment_modal_header_language_unavailable: string | undefined;
    assessment_questions_incomplete: string | undefined;
    assessment_modal_body_language_unavailable: string | undefined;
    assessment_questions_message_incomplete: string | undefined;
    assessment_questions_completed: string | undefined;
    assessment_questions_message_completed: string | undefined;
    assessment_button_back_to_dashboard: string | undefined;
    assessments_contact_message: string | undefined;

    header_link_profile: string | undefined;
    header_link_assessments: string | undefined;
    header_link_dashboard: string | undefined;
    header_link_projects: string | undefined;
    header_link_reports: string | undefined;
    header_link_logout: string | undefined;

    pwChange_modal_title: string | undefined;
    pwChange_label_password1: string | undefined;
    pwChange_label_password2: string | undefined;
    pwChange_placeholder_password1: string | undefined;
    pwChange_placeholder_password2: string | undefined;
    pwChange_button: string | undefined;
    pwChange_button_newUser: string | undefined;
    pwChange_criteria_length: string | undefined;
    pwChange_criteria_lowecase: string | undefined;
    pwChange_criteria_uppercase: string | undefined;
    pwChange_criteria_number: string | undefined;
    pwChange_criteria_match: string | undefined;
    pwChange_status_modal_title: string | undefined;
    pwChange_status_message_success: string | undefined;
    pwChange_status_message_success_newUser: string | undefined;
    pwChange_reRequest_message: string | undefined;
    pwChange_reRequest_button: string | undefined;
    pwChange_reRequest_message_success: string | undefined;
    pwChange_pageTitle_tokenExpired: string | undefined;
    pwChange_pageTitle_newUser: string | undefined;
    pwChange_pageTitle_currentUser: string | undefined;
    pwChange_privacyPolicyMessage: string | undefined;
    pwChange_privacyPolicy: string | undefined;
    pwChange_updating: string | undefined;
    pwChange_show_password: string | undefined;
    pwChange_hide_password: string | undefined;

    dash_minute: string | undefined,
    dash_minutes: string | undefined,
    dash_title_recentlyCompleted: string | undefined,
    dash_assessmentStatus: string | undefined;
    dash_outOf: string | undefined;
    dash_completed: string | undefined;
    dash_noComplete: string | undefined;
    dash_title_activeQuestionnaires: string | undefined;
    dash_noActive: string | undefined;
    dash_caughtUp: string | undefined;
    dash_tooltip_reopen: string | undefined;
    dash_manageObservers: string | undefined;
    dash_observers: string | undefined;
    dash_with: string | undefined;
    dash_button_start: string | undefined;
    dash_button_reopen: string | undefined;
    dash_button_resume: string | undefined;
    dash_button_expired: string | undefined;
    dash_due: string | undefined;
    dash_pastDue: string | undefined;
    dash_questions: string | undefined;
    dash_estimated: string | undefined;
    dash_modal_header_remind_observers: string | undefined;
    dash_modal_body_remind_observers: string | undefined;
    dash_observer_button_addObservers: string | undefined;
    dash_observer_header_name: string | undefined;
    dash_observer_header_email: string | undefined;
    dash_observer_header_status: string | undefined;
    dash_observer_header_type: string | undefined;
    dash_observer_header_language: string | undefined;
    dash_observer_header_due: string | undefined;
    dash_observer_header_actions: string | undefined;
    dash_observer_tooltip_delete: string | undefined;
    dash_observer_tooltip_email: string | undefined;
    dash_observer_tooltip_edit: string | undefined;
    dash_observer_finishedUpdating: string | undefined;
    dash_observer_errorUpdating: string | undefined;
    dash_observer_delete_confirm: string | undefined;
    dash_observer_remind_confirm: string | undefined;
    dash_observer_finishedDeleting: string | undefined;
    dash_observer_errorDeleting: string | undefined;
    dash_observer_finishedReminding: string | undefined;
    dash_observer_errorReminding: string | undefined;
    dash_observer_button_finishedAdding: string | undefined;
    dash_modal_header_add: string | undefined;
    dash_add_observer_instructions: string | undefined;
    dash_observer_add_header_email: string | undefined;
    dash_observer_add_header_firstName: string | undefined;
    dash_observer_add_header_lastName: string | undefined;
    dash_observer_add_header_language: string | undefined;
    dash_observer_add_header_type: string | undefined;
    dash_observer_button_add: string | undefined;
    dash_observer_duplicate: string | undefined;
    dash_observer_add_header_due: string | undefined,

    profile_label_name: string | undefined;
    profile_label_email: string | undefined;
    profile_label_username: string | undefined;
    profile_label_changePassword: string | undefined;
    profile_label_language: string | undefined;
    profile_label_company: string | undefined;
    profile_section_title_account: string | undefined;
    profile_section_title_preferences: string | undefined;
    profile_section_none_preferences: string | undefined;
    profile_section_title_demographics: string | undefined;
    profile_section_subTitle_demographics: string | undefined;
    profile_section_none_demographics: string | undefined;
    profile_password_modal_header: string | undefined;
    profile_password_nested_modal_header: string | undefined;
    profile_password_nested_modal_message: string | undefined;
    profile_available: string | undefined;
    profile_unavailable: string | undefined;
    profile_valid_email: string | undefined;
    profile_nonvalid_email: string | undefined;
    profile_unavailable_email: string | undefined;
    mapTranslations(translations: ITranslation[]): void;
}

export class AppTranslations implements IAppTranslations {
    /**
     *
     */
    constructor(translations: ITranslation[]) {
        this.mapTranslations(translations);
    }
    common_continue: string | undefined;
    common_help: string | undefined;
    common_edit: string | undefined;
    common_close: string | undefined;
    common_update: string | undefined;
    common_yes: string | undefined;
    common_no: string | undefined;
    common_confirmation: string | undefined;
    common_warning: string | undefined;
    common_okay: string | undefined;
    common_save: string | undefined;
    common_submit: string | undefined;

    assessment_questions_unanswered: string | undefined;
    assessment_observer: string | undefined;
    assessment_demographics: string | undefined;
    assessment_saveAndExit: string | undefined;
    assessment_approx_time_left: string | undefined;
    assessment_yourDemographics: string | undefined;
    assessment_questions_most: string | undefined;
    assessment_questions_next: string | undefined;
    assessment_questions_noComment: string | undefined;
    assessment_questions_noCommentChoice: string | undefined;
    assessment_questions_section: string | undefined;
    assessment_questions_instructions: string | undefined;
    assessment_button_nextSection: string | undefined;
    assessment_button_allDone: string | undefined;
    assessment_button_firstQuestion: string | undefined;
    assessment_submit_demographics: string | undefined;
    assessment_button_back: string | undefined;
    assessment_return_message: string | undefined;
    assessment_welcome_back: string | undefined;
    assessment_modal_header_language_unavailable: string | undefined;
    assessment_questions_incomplete: string | undefined;
    assessment_modal_body_language_unavailable: string | undefined;
    assessment_questions_message_incomplete: string | undefined;
    assessment_questions_completed: string | undefined;
    assessment_questions_message_completed: string | undefined;
    assessment_button_back_to_dashboard: string | undefined;
    assessments_contact_message: string | undefined;
    assessment_submit_failed_body: string | undefined;
    assessment_submit_failed_header: string | undefined;

    header_link_profile: string | undefined;
    header_link_assessments: string | undefined;
    header_link_dashboard: string | undefined;
    header_link_projects: string | undefined;
    header_link_reports: string | undefined;
    header_link_logout: string | undefined;
    pwChange_modal_title: string | undefined;
    pwChange_label_password1: string | undefined;
    pwChange_label_password2: string | undefined;
    pwChange_placeholder_password1: string | undefined;
    pwChange_placeholder_password2: string | undefined;
    pwChange_button: string | undefined;
    pwChange_button_newUser: string | undefined;
    pwChange_criteria_length: string | undefined;
    pwChange_criteria_lowecase: string | undefined;
    pwChange_criteria_uppercase: string | undefined;
    pwChange_criteria_number: string | undefined;
    pwChange_criteria_match: string | undefined;
    pwChange_status_modal_title: string | undefined;
    pwChange_status_message_success: string | undefined;
    pwChange_status_message_success_newUser: string | undefined;
    pwChange_reRequest_message: string | undefined;
    pwChange_reRequest_button: string | undefined;
    pwChange_reRequest_message_success: string | undefined;
    pwChange_pageTitle_tokenExpired: string | undefined;
    pwChange_pageTitle_newUser: string | undefined;
    pwChange_pageTitle_currentUser: string | undefined;
    pwChange_privacyPolicyMessage: string | undefined;
    pwChange_privacyPolicy: string | undefined;
    pwChange_updating: string | undefined;
    pwChange_show_password: string | undefined;
    pwChange_hide_password: string | undefined;
    dash_minute: string | undefined;
    dash_minutes: string | undefined;
    dash_title_recentlyCompleted: string | undefined;
    dash_assessmentStatus: string | undefined;
    dash_outOf: string | undefined;
    dash_completed: string | undefined;
    dash_noComplete: string | undefined;
    dash_title_activeQuestionnaires: string | undefined;
    dash_noActive: string | undefined;
    dash_caughtUp: string | undefined;
    dash_tooltip_reopen: string | undefined;
    dash_manageObservers: string | undefined;
    dash_observers: string | undefined;
    dash_with: string | undefined;
    dash_button_start: string | undefined;
    dash_button_reopen: string | undefined;
    dash_button_resume: string | undefined;
    dash_button_expired: string | undefined;
    dash_due: string | undefined;
    dash_pastDue: string | undefined;
    dash_questions: string | undefined;
    dash_estimated: string | undefined;
    dash_modal_header_remind_observers: string | undefined;
    dash_modal_body_remind_observers: string | undefined;
    dash_observer_button_addObservers: string | undefined;
    dash_observer_header_name: string | undefined;
    dash_observer_header_email: string | undefined;
    dash_observer_header_status: string | undefined;
    dash_observer_header_type: string | undefined;
    dash_observer_header_language: string | undefined;
    dash_observer_header_due: string | undefined;
    dash_observer_header_actions: string | undefined;
    dash_observer_tooltip_delete: string | undefined;
    dash_observer_tooltip_email: string | undefined;
    dash_observer_tooltip_edit: string | undefined;
    dash_observer_finishedUpdating: string | undefined;
    dash_observer_errorUpdating: string | undefined;
    dash_observer_delete_confirm: string | undefined;
    dash_observer_remind_confirm: string | undefined;
    dash_observer_finishedDeleting: string | undefined;
    dash_observer_errorDeleting: string | undefined;
    dash_observer_finishedReminding: string | undefined;
    dash_observer_errorReminding: string | undefined;
    dash_observer_button_finishedAdding: string | undefined;
    dash_modal_header_add: string | undefined;
    dash_add_observer_instructions: string | undefined;
    dash_observer_add_header_email: string | undefined;
    dash_observer_add_header_firstName: string | undefined;
    dash_observer_add_header_lastName: string | undefined;
    dash_observer_add_header_language: string | undefined;
    dash_observer_add_header_type: string | undefined;
    dash_observer_button_add: string | undefined;
    dash_observer_duplicate: string | undefined;
    dash_observer_add_header_due: string | undefined;
    profile_label_name: string | undefined;
    profile_label_email: string | undefined;
    profile_label_username: string | undefined;
    profile_label_changePassword: string | undefined;
    profile_label_language: string | undefined;
    profile_label_company: string | undefined;
    profile_section_title_account: string | undefined;
    profile_section_title_preferences: string | undefined;
    profile_section_none_preferences: string | undefined;
    profile_section_title_demographics: string | undefined;
    profile_section_subTitle_demographics: string | undefined;
    profile_section_none_demographics: string | undefined;
    profile_password_modal_header: string | undefined;
    profile_password_nested_modal_header: string | undefined;
    profile_password_nested_modal_message: string | undefined;
    profile_available: string | undefined;
    profile_unavailable: string | undefined;
    profile_valid_email: string | undefined;
    profile_nonvalid_email: string | undefined;
    profile_unavailable_email: string | undefined;
    profile_review_text: string | undefined;

    mapTranslations(translations: ITranslation[]): void {
        this.common_continue = this.findTranslation(translations, 'common_continue');
        this.common_edit = this.findTranslation(translations, 'common_edit');
        this.common_close = this.findTranslation(translations, 'common_close');
        this.common_update = this.findTranslation(translations, 'common_update');
        this.common_help = this.findTranslation(translations, 'common_help');
        this.common_yes = this.findTranslation(translations, 'common_yes');
        this.common_no = this.findTranslation(translations, 'common_no');
        this.common_confirmation = this.findTranslation(translations, 'common_confirmation');
        this.common_warning = this.findTranslation(translations, 'common_warning');
        this.common_okay = this.findTranslation(translations, 'common_okay');
        this.common_save = this.findTranslation(translations, 'common_save');
        this.common_submit = this.findTranslation(translations, 'common_submit');

        this.header_link_profile = this.findTranslation(translations, 'header_link_profile');
        this.header_link_assessments = this.findTranslation(translations, 'header_link_assessments');
        this.header_link_logout = this.findTranslation(translations, 'header_link_logout');
        this.header_link_reports = this.findTranslation(translations, 'header_link_reports');
        this.header_link_projects = this.findTranslation(translations, 'header_link_projects');
        this.header_link_dashboard = this.findTranslation(translations, 'header_link_dashboard');

        this.assessment_observer = this.findTranslation(translations, 'assessment_observer');
        this.assessment_demographics = this.findTranslation(translations, 'assessment_demographics');
        this.assessment_approx_time_left = this.findTranslation(translations, 'assessment_approx_time_left');
        this.assessment_saveAndExit = this.findTranslation(translations, 'assessment_saveAndExit');
        this.assessment_questions_unanswered = this.findTranslation(translations, 'assessment_questions_unanswered');
        this.assessment_yourDemographics = this.findTranslation(translations, 'assessment_yourDemographics');
        this.assessment_questions_most = this.findTranslation(translations, 'assessment_questions_most');
        this.assessment_questions_next = this.findTranslation(translations, 'assessment_questions_next');
        this.assessment_questions_noComment = this.findTranslation(translations, 'assessment_questions_noComment');
        this.assessment_questions_noCommentChoice = this.findTranslation(translations, 'assessment_questions_noCommentChoice');
        this.assessment_questions_instructions = this.findTranslation(translations, 'assessment_questions_instructions');
        this.assessment_questions_section = this.findTranslation(translations, 'assessment_questions_section');
        this.assessment_button_nextSection = this.findTranslation(translations, 'assessment_button_nextSection');
        this.assessment_button_allDone = this.findTranslation(translations, 'assessment_button_allDone');
        this.assessment_button_back = this.findTranslation(translations, 'assessment_button_back');
        this.assessment_button_firstQuestion = this.findTranslation(translations, 'assessment_button_firstQuestion');
        this.assessment_submit_demographics = this.findTranslation(translations, 'assessment_submit_demographics');
        this.assessment_return_message = this.findTranslation(translations, 'assessment_return_message');
        this.assessment_welcome_back = this.findTranslation(translations, 'assessment_welcome_back');
        this.assessment_modal_header_language_unavailable = this.findTranslation(translations, 'assessment_modal_header_language_unavailable');
        this.assessment_questions_incomplete = this.findTranslation(translations, 'assessment_questions_incomplete');
        this.assessment_modal_body_language_unavailable = this.findTranslation(translations, 'assessment_modal_body_language_unavailable');
        this.assessment_questions_message_incomplete = this.findTranslation(translations, 'assessment_questions_message_incomplete');
        this.assessment_questions_completed = this.findTranslation(translations, 'assessment_questions_completed');
        this.assessment_questions_message_completed = this.findTranslation(translations, 'assessment_questions_message_completed');
        this.assessment_button_back_to_dashboard = this.findTranslation(translations, 'assessment_button_back_to_dashboard');
        this.assessments_contact_message = this.findTranslation(translations, 'assessments_contact_message');
        this.assessment_submit_failed_body = this.findTranslation(translations, 'assessment_submit_failed_body');
        this.assessment_submit_failed_header = this.findTranslation(translations, 'assessment_submit_failed_header');

        this.pwChange_modal_title = this.findTranslation(translations, 'pwChange_modal_title');
        this.pwChange_label_password1 = this.findTranslation(translations, 'pwChange_label_password1');
        this.pwChange_label_password2 = this.findTranslation(translations, 'pwChange_label_password2');
        this.pwChange_placeholder_password1 = this.findTranslation(translations, 'pwChange_placeholder_password1');
        this.pwChange_placeholder_password2 = this.findTranslation(translations, 'pwChange_placeholder_password2');
        this.pwChange_button = this.findTranslation(translations, 'pwChange_button');
        this.pwChange_button_newUser = this.findTranslation(translations, 'pwChange_button_newUser');
        this.pwChange_criteria_length = this.findTranslation(translations, 'pwChange_criteria_length');
        this.pwChange_criteria_lowecase = this.findTranslation(translations, 'pwChange_criteria_lowecase');
        this.pwChange_criteria_uppercase = this.findTranslation(translations, 'pwChange_criteria_uppercase');
        this.pwChange_criteria_number = this.findTranslation(translations, 'pwChange_criteria_number');
        this.pwChange_criteria_match = this.findTranslation(translations, 'pwChange_criteria_match');
        this.pwChange_status_modal_title = this.findTranslation(translations, 'pwChange_status_modal_title');
        this.pwChange_status_message_success = this.findTranslation(translations, 'pwChange_status_message_success');
        this.pwChange_status_message_success_newUser = this.findTranslation(translations, 'pwChange_status_message_success_newUser');
        this.pwChange_reRequest_message = this.findTranslation(translations, 'pwChange_reRequest_message');
        this.pwChange_reRequest_button = this.findTranslation(translations, 'pwChange_reRequest_button');
        this.pwChange_reRequest_message_success = this.findTranslation(translations, 'pwChange_reRequest_message_success');
        this.pwChange_pageTitle_tokenExpired = this.findTranslation(translations, 'pwChange_pageTitle_tokenExpired');
        this.pwChange_pageTitle_newUser = this.findTranslation(translations, 'pwChange_pageTitle_newUser');
        this.pwChange_pageTitle_currentUser = this.findTranslation(translations, 'pwChange_pageTitle_currentUser');
        this.pwChange_privacyPolicyMessage = this.findTranslation(translations, 'pwChange_privacyPolicyMessage');
        this.pwChange_privacyPolicy = this.findTranslation(translations, 'pwChange_privacyPolicy');
        this.pwChange_updating = this.findTranslation(translations, 'pwChange_updating');
        this.pwChange_show_password = this.findTranslation(translations, 'pwChange_show_password');
        this.pwChange_hide_password = this.findTranslation(translations, 'pwChange_hide_password');

        this.dash_title_activeQuestionnaires = this.findTranslation(translations, 'dash_title_activeQuestionnaires');
        this.dash_title_recentlyCompleted = this.findTranslation(translations, 'dash_title_recentlyCompleted');
        this.dash_minute = this.findTranslation(translations, 'dash_minute');
        this.dash_assessmentStatus = this.findTranslation(translations, 'dash_assessmentStatus');
        this.dash_outOf = this.findTranslation(translations, 'dash_outOf');
        this.dash_completed = this.findTranslation(translations, 'dash_completed');
        this.dash_noComplete = this.findTranslation(translations, 'dash_noComplete');
        this.dash_noActive = this.findTranslation(translations, 'dash_noActive');
        this.dash_caughtUp = this.findTranslation(translations, 'dash_caughtUp');
        this.dash_tooltip_reopen = this.findTranslation(translations, 'dash_tooltip_reopen');
        this.dash_manageObservers = this.findTranslation(translations, 'dash_manageObservers');
        this.dash_with = this.findTranslation(translations, 'dash_with');
        this.dash_button_start = this.findTranslation(translations, 'dash_button_start');
        this.dash_button_reopen = this.findTranslation(translations, 'dash_button_reopen');
        this.dash_button_resume = this.findTranslation(translations, 'dash_button_resume');
        this.dash_button_expired = this.findTranslation(translations, 'dash_button_expired');
        this.dash_due = this.findTranslation(translations, 'dash_due');
        this.dash_pastDue = this.findTranslation(translations, 'dash_pastDue');
        this.dash_questions = this.findTranslation(translations, 'dash_questions');
        this.dash_estimated = this.findTranslation(translations, 'dash_estimated');
        this.dash_minutes = this.findTranslation(translations, 'dash_minutes');
        this.dash_modal_header_remind_observers = this.findTranslation(translations, 'dash_modal_header_remind_observers');
        this.dash_modal_body_remind_observers = this.findTranslation(translations, 'dash_modal_body_remind_observers');
        this.dash_modal_header_add = this.findTranslation(translations, 'dash_modal_header_add');
        this.dash_add_observer_instructions = this.findTranslation(translations, 'dash_add_observer_instructions');
        this.dash_observers = this.findTranslation(translations, 'dash_observers');
        this.dash_observer_button_addObservers = this.findTranslation(translations, 'dash_observer_button_addObservers');
        this.dash_observer_header_name = this.findTranslation(translations, 'dash_observer_header_name');
        this.dash_observer_header_email = this.findTranslation(translations, 'dash_observer_header_email');
        this.dash_observer_header_status = this.findTranslation(translations, 'dash_observer_header_status');
        this.dash_observer_header_type = this.findTranslation(translations, 'dash_observer_header_type');
        this.dash_observer_header_due = this.findTranslation(translations, 'dash_observer_header_due');
        this.dash_observer_header_actions = this.findTranslation(translations, 'dash_observer_header_actions');
        this.dash_observer_header_language = this.findTranslation(translations, 'dash_observer_header_language');
        this.dash_observer_tooltip_delete = this.findTranslation(translations, 'dash_observer_tooltip_delete');
        this.dash_observer_tooltip_email = this.findTranslation(translations, 'dash_observer_tooltip_email');
        this.dash_observer_tooltip_edit = this.findTranslation(translations, 'dash_observer_tooltip_edit');
        this.dash_observer_finishedUpdating = this.findTranslation(translations, 'dash_observer_finishedUpdating');
        this.dash_observer_errorUpdating = this.findTranslation(translations, 'dash_observer_errorUpdating');
        this.dash_observer_delete_confirm = this.findTranslation(translations, 'dash_observer_delete_confirm');
        this.dash_observer_remind_confirm = this.findTranslation(translations, 'dash_observer_remind_confirm');
        this.dash_observer_finishedDeleting = this.findTranslation(translations, 'dash_observer_finishedDeleting');
        this.dash_observer_errorDeleting = this.findTranslation(translations, 'dash_observer_errorDeleting');
        this.dash_observer_finishedReminding = this.findTranslation(translations, 'dash_observer_finishedReminding');
        this.dash_observer_errorReminding = this.findTranslation(translations, 'dash_observer_errorReminding');
        this.dash_observer_button_finishedAdding = this.findTranslation(translations, 'dash_observer_button_finishedAdding');
        this.dash_observer_add_header_email = this.findTranslation(translations, 'dash_observer_add_header_email');
        this.dash_observer_add_header_firstName = this.findTranslation(translations, 'dash_observer_add_header_firstName');
        this.dash_observer_add_header_lastName = this.findTranslation(translations, 'dash_observer_add_header_lastName');
        this.dash_observer_add_header_language = this.findTranslation(translations, 'dash_observer_add_header_language');
        this.dash_observer_add_header_type = this.findTranslation(translations, 'dash_observer_add_header_type');
        this.dash_observer_add_header_due = this.findTranslation(translations, 'dash_observer_add_header_due');
        this.dash_observer_button_add = this.findTranslation(translations, 'dash_observer_button_add');
        this.dash_observer_duplicate = this.findTranslation(translations, 'dash_observer_duplicate');

        this.profile_label_name = this.findTranslation(translations, 'profile_label_name');
        this.profile_label_email = this.findTranslation(translations, 'profile_label_email');
        this.profile_label_username = this.findTranslation(translations, 'profile_label_username');
        this.profile_label_changePassword = this.findTranslation(translations, 'profile_label_changePassword');
        this.profile_label_language = this.findTranslation(translations, 'profile_label_language');
        this.profile_label_company = this.findTranslation(translations, 'profile_label_company');
        this.profile_section_title_account = this.findTranslation(translations, 'profile_section_title_account');
        this.profile_section_title_preferences = this.findTranslation(translations, 'profile_section_title_preferences');
        this.profile_section_none_preferences = this.findTranslation(translations, 'profile_section_none_preferences');
        this.profile_section_title_demographics = this.findTranslation(translations, 'profile_section_title_demographics');
        this.profile_section_subTitle_demographics = this.findTranslation(translations, 'profile_section_subTitle_demographics');
        this.profile_section_none_demographics = this.findTranslation(translations, 'profile_section_none_demographics');
        this.profile_password_modal_header = this.findTranslation(translations, 'profile_password_modal_header');
        this.profile_password_nested_modal_header = this.findTranslation(translations, 'profile_password_nested_modal_header');
        this.profile_password_nested_modal_message = this.findTranslation(translations, 'profile_password_nested_modal_message');
        this.profile_available = this.findTranslation(translations, 'profile_available');
        this.profile_unavailable = this.findTranslation(translations, 'profile_unavailable');
        this.profile_valid_email = this.findTranslation(translations, 'profile_valid_email');
        this.profile_nonvalid_email = this.findTranslation(translations, 'profile_nonvalid_email');
        this.profile_unavailable_email = this.findTranslation(translations, 'profile_unavailable_email');
        this.profile_review_text = this.findTranslation(translations, 'profile_review_text');
    }


    findTranslation(translations: ITranslation[], key: string): string {
        const translation = translations.find(t => t.key === key);
        if (translation) {
            return translation.value;
        }
        return '';
    }
}
